/** @format */

export enum ImageBadge {
  CLOSEOUT = 'bat_rack_closeout',
  CLOSEOUT_WITH_A_SPACE = 'bat rack closeout',
  CUSTOMIZABLE = 'CustomizeIt',
  DICKS_EXCLUSIVE = 'DicksExclusive',
  EXTENDED_SIZES = 'Extended_Sizes',
  EXTENDED_SIZES_WITH_A_SPACE = 'Extended Sizes',
  FAN_SHOP_SHIP = 'FanShopShip',
  GOLD_EXCLUSIVE = 'gold',
  NEW_ARRIVALS = 'NewArrivals',
  NIKE_EXCLUSIVE = 'nike',
  PERSONALIZED = 'PersonalizedItem',
  TOP_SELLER = 'TopSeller',
  USED_CLUB = 'Used',
}

export enum ImageBadgeFile {
  'CustomizeIt' = 'Customize-It-PDP',
  'DicksExclusive' = 'Only-at-DICKS-PDP',
  'Extended_Sizes' = 'Extended-Sizes-PDP',
  'FanShopShip' = 'Fan-Shop-Ship-PDP',
  'NewArrivals' = 'NewArrivals-PDP',
  'PersonalizedItem' = 'Personalized-PDP',
  'TopSeller' = 'Top-Seller-PDP',
  'Used' = 'UsedClub-PDP',
  'bat_rack_closeout' = 'Closeout-Bat-PDP',
  'gold' = 'Gold-Exclusive-PDP',
  'nike' = 'Nike-Exclusive',
}
